import {
  ADD_VENDOR_FAILURE,
  ADD_VENDOR_REQUEST,
  ADD_VENDOR_SUCCESS,
  CLEAR_VENDOR_DELETE_SUCCESS,
  DELETE_VENDOR_FAILURE,
  DELETE_VENDOR_REQUEST,
  DELETE_VENDOR_SUCCESS,
  FETCH_ALL_VENDORS_FAILURE,
  FETCH_ALL_VENDORS_REQUEST,
  FETCH_ALL_VENDORS_SUCCESS,
  FETCH_CUSTOMERS_BY_VENDOR_FAILURE,
  FETCH_CUSTOMERS_BY_VENDOR_REQUEST,
  FETCH_CUSTOMERS_BY_VENDOR_SUCCESS,
  FETCH_VENDOR_DETAILS_FAILURE,
  FETCH_VENDOR_DETAILS_REQUEST,
  FETCH_VENDOR_DETAILS_SUCCESS,
  FETCH_VENDORS_FAILURE,
  FETCH_VENDORS_REQUEST,
  FETCH_VENDORS_SUCCESS,
  RESET_VENDOR_STATE,
  UPDATE_VENDOR_APPROVAL_STATUS_FAILURE,
  UPDATE_VENDOR_APPROVAL_STATUS_REQUEST,
  UPDATE_VENDOR_APPROVAL_STATUS_SUCCESS,
  UPDATE_VENDOR_FAILURE,
  UPDATE_VENDOR_REQUEST,
  UPDATE_VENDOR_SUCCESS
} from "../types/vendorTypes";

const initialState = {
  vendors: {
    data: [],
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    error: null,

    success: false,
    deleteSuccess: false
  },
  vendorDetails: {
    data: null,
    loading: false,
    error: null,
    success: false,
    approval_message: null,
    updateLoading: false,
    deleteLoading: false
  },
  success: {
    add: false,
    update: false,
    delete: false
  },
  customers: [],
  loading: false,
  error: null
};

const vendorReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_VENDOR_REQUEST:
      return {
        ...state,

        vendorDetails: {
          ...state.vendorDetails,
          success: false,
          loading: true,
          approval_message: null,
          updateLoading: false,
          deleteLoading: false
        },
        error: null
      };
    case UPDATE_VENDOR_REQUEST:
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,
          success: false,
          loading: false,
          updateLoading: true,
          approval_message: null,
          deleteLoading: false
        }
      };
    case FETCH_VENDORS_REQUEST:
    case FETCH_ALL_VENDORS_REQUEST:
      return {
        ...state,
        vendors: {
          ...state.vendors,
          loading: true,
          error: null,
          success: false,
          deleteSuccess: false
        },
        error: null
      };
    case FETCH_VENDOR_DETAILS_REQUEST:
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,
          success: false,
          loading: true,
          updateLoading: false,
          deleteLoading: false
        }
      };
    case DELETE_VENDOR_REQUEST:
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,
          success: false,
          loading: false,
          approval_message: null,
          updateLoading: false,
          deleteLoading: true
        },
        error: null
      };

    case FETCH_VENDORS_SUCCESS:
    case FETCH_ALL_VENDORS_SUCCESS:
      return {
        ...state,
        vendors: {
          ...state.vendors,
          data: action.payload.data || [],
          totalRecords: action.payload.totalRecords || 0,
          totalPages: action.payload.totalPages || 0,
          currentPage: action.payload.currentPage || 1,
          loading: false,
          success: true,
          error: null
        }
      };

    case FETCH_VENDOR_DETAILS_SUCCESS:
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,
          data: action.payload,
          error: null,
          success: false,
          approval_message: null,
          loading: false,
          updateLoading: false,
          deleteLoading: false
        }
      };

    case DELETE_VENDOR_SUCCESS:
      console.log("vendor delte", action.payload);
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,
          error: null,
          success: true,
          loading: false,
          approval_message: null,
          updateLoading: false,
          deleteLoading: false
        }
      };

    case UPDATE_VENDOR_SUCCESS:
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,
          error: null,
          success: true,
          loading: false,
          approval_message: null,
          updateLoading: false,
          deleteLoading: false
        }
      };

    case ADD_VENDOR_SUCCESS:
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,
          success: true,
          loading: false,
          error: null,
          approval_message: null,
          updateLoading: false,
          deleteLoading: false
        },
        error: null
      };

    case ADD_VENDOR_FAILURE:
    case UPDATE_VENDOR_FAILURE:
    case DELETE_VENDOR_FAILURE:
    case FETCH_VENDOR_DETAILS_FAILURE:
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,
          data: null,
          loading: false,
          success: false,
          updateLoading: false,
          approval_message: null,
          deleteLoading: false,
          error: action.payload
        },
        error: action.payload
      };

    case FETCH_VENDORS_FAILURE:
    case FETCH_ALL_VENDORS_FAILURE:
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,
          loading: false,
          deleteSuccess: false,
          approval_message: null,
          success: false,
          error: action.payload
        },

        error: action.payload
      };

    case RESET_VENDOR_STATE:
      return {
        ...state,
        success: {
          add: false,
          update: false,
          delete: false
        },
        error: null,
        vendorDetails: {
          ...state.vendorDetails,
          data: null,
          approval_message: null,
          loading: false,
          error: null,
          success: false
        },
        vendors: {
          ...state.vendors,
          data: [],
          loading: false,
          error: null,
          success: false,
          deleteSuccess: false
        }
      };

    case CLEAR_VENDOR_DELETE_SUCCESS:
      return {
        ...state,
        vendors: { ...state.vendors, deleteSuccess: false }
      };

    case UPDATE_VENDOR_APPROVAL_STATUS_REQUEST:
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,

          loading: false,
          error: null,
          success: false,
          approval_message: null,
          updateLoading: true,
          deleteLoading: false
        }
      };

    case UPDATE_VENDOR_APPROVAL_STATUS_SUCCESS:
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,
          data: action.payload?.data,
          loading: false,
          error: null,
          success: false,
          approval_message: action.payload?.message,
          updateLoading: false,
          deleteLoading: false
        }
      };

    case UPDATE_VENDOR_APPROVAL_STATUS_FAILURE:
      return {
        ...state,
        vendorDetails: {
          ...state.vendorDetails,
          data: null,
          loading: false,
          updateLoading: false,
          success: false,
          deleteLoading: false,
          error: action.payload
        }
      };

    case FETCH_CUSTOMERS_BY_VENDOR_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_CUSTOMERS_BY_VENDOR_SUCCESS:
      return { ...state, loading: false, customers: action.payload };
    case FETCH_CUSTOMERS_BY_VENDOR_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default vendorReducer;
